import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCelularAlteracao from '../../../components/form/InputCelularAlteracao';
import InputCelularEstrangeiro from '../../../components/form/InputCelularEstrangeiro';
import InputCadastroComIcone from '../../../components/form/InputCadastroComIcone';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { createFormSchemas } from './FormSchema';
import {
  ENVIAR_TOKEN_PARA_EMAIL,
  ENVIAR_TOKEN,
  ALTERAR_TELEFONE,
} from '../../../services/meuCorreios';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import InputToken from '../../../components/form/InputToken';
import { getIPAddress } from '../../../components/utils/GetIPAddress';

function FormAlterarTelefone({
  acaoCancelar,
  acaoFechar,
  dados,
  dadosDependente,
}) {
  const { t } = useTranslation();
  const { formSchemaTelefone } = createFormSchemas(t);
  const methods = useForm({ resolver: yupResolver(formSchemaTelefone) });
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
    handleReset();
  }, []);
  useEffect(() => {
    handleReset();
  }, [dados, dadosDependente]);
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };
  const [brasileiro, setBrasileiro] = React.useState(true);

  useEffect(() => {
    if (
      (dados?.usuarioExternoPF?.tipoEstrangeiro !== undefined &&
        dados?.usuarioExternoPF?.tipoEstrangeiro !== 'N') ||
      (dados?.usuarioExternoPJ?.sediadaForaBrasil !== undefined &&
        dados?.usuarioExternoPJ?.sediadaForaBrasil !== 'N')
    ) {
      setBrasileiro(false);
    } else {
      setBrasileiro(true);
    }
  }, [dados]);
  const [modalAbertoTelefone, setModalAbertoTelefone] = React.useState(true);
  const [modalAbertoToken, setModalAbertoToken] = React.useState(false);

  const formatarEmailMascarado = (email) => {
    const emailTexto = (email || '').toString().trim();
    if (!emailTexto) {
      return '';
    }
    const [usuario, dominio] = emailTexto.split('@');
    if (!dominio) {
      return `${emailTexto.slice(0, 2)}***`;
    }
    const sufixoUsuario =
      usuario.length <= 4 ? usuario.slice(-1) : usuario.slice(-2);

    return `${(usuario || '').slice(0, 2)}***${sufixoUsuario}@${dominio}`;
  };

  const openModalToken = () => {
    setModalAbertoTelefone(false);
    setModalAbertoToken(true);
  };
  const [ddiMovel, setDdiMovel] = React.useState('55');
  const [dddMovel, setDddMovel] = React.useState();
  const [foneMovel, setFoneMovel] = React.useState();

  const handleSubmit = async (data) => {
    var alterou = false;

    if (dadosDependente) {
      if (
        dadosDependente.dddMovel != data.dddMovel ||
        dadosDependente.foneMovel != data.foneMovel
      ) {
        alterou = true;
      }
    } else {
      if (
        (data.ddiMovel && data.ddiMovel != dados.ddiMovel) ||
        dados.foneMovel != data.foneMovel ||
        dados.dddMovel != data.dddMovel
      ) {
        alterou = true;
      }
    }
    if (alterou) {
      setDdiMovel(data.ddiMovel || dados.ddiMovel || '55');
      setDddMovel(data.dddMovel);
      setFoneMovel(data.foneMovel.replace(/[\(\)\-\s]/g, ''));
      var usuario = dados.idCorreios;
      const token = {
        meioEnvio: 'E',
        funcionalidade: 'ALTERAR_TELEFONE',
        email: dados.email,
      };
      if (dadosDependente) {
        Object.assign(token, { dependente: dadosDependente.idCorreios });
      }
      const { response } = await request(
        ENVIAR_TOKEN_PARA_EMAIL(usuario, token, ipAddress),
      );
      if (response.ok) {
        abreAlertaDialog(t('principal.messages.success.token_sent_email'));
        openModalToken();
      }
    } else {
      abreAlertaDialog(t('principal.messages.success.phone_not_changed'));
    }
    /* const token = {
      meioEnvio: 'E',
      funcionalidade: 'ALTERAR_TELEFONE',
      //email: dados.email,
    };
    const { response } = await request(ENVIAR_TOKEN(usuario, token, ipAddress));
    if (response.ok) {
      abreAlertaDialog('Token enviado com sucesso para seu E-mail.');
      openModalToken();
    }*/
  };
  const alterar = async () => {
    const token =
      document.getElementById('confirmarSenha1').value +
      document.getElementById('confirmarSenha2').value +
      document.getElementById('confirmarSenha3').value +
      document.getElementById('confirmarSenha4').value +
      document.getElementById('confirmarSenha5').value +
      document.getElementById('confirmarSenha6').value;
    if (token.length < 6) {
      abreAlertaDialog(t('principal.messages.validation.token_digits_required'));
    } else {
      const telefone = {
        ddiMovel: ddiMovel || '55',
        dddMovel: dddMovel,
        foneMovel: foneMovel,
      };
      var usuario;
      if (dadosDependente) {
        usuario = dadosDependente.idCorreios;
      } else {
        usuario = dados.idCorreios;
      }
      const { response } = await request(
        ALTERAR_TELEFONE(dados.idCorreios, usuario, token, telefone, ipAddress),
      );

      if (response.ok) {
        abreAlertaDialog(t('principal.messages.success.phone_changed'));
        setModalAbertoToken(false);
        setModalAbertoTelefone(true);
        acaoFechar();
      }
    }
  };

  const { request } = useFetch();
  const reenviaToken = async () => {
    var usuario = dados.idCorreios;
    const token = {
      meioEnvio: 'E',
      funcionalidade: 'ALTERAR_TELEFONE',
      email: dados.email,
    };
    if (dadosDependente) {
      Object.assign(token, { dependente: dadosDependente.idCorreios });
    }
    const { response } = await request(
      ENVIAR_TOKEN_PARA_EMAIL(dados.idCorreios, token, ipAddress),
    );
    if (response.ok) {
      abreAlertaDialog(t('principal.messages.success.token_sent_email'));
    }
  };
  const fecharToken = (ev) => {
    ev.preventDefault();
    setModalAbertoTelefone(true);
    setModalAbertoToken(false);
    acaoCancelar();
  };
  const fechar = (ev) => {
    ev.preventDefault();
    setModalAbertoTelefone(true);
    setModalAbertoToken(false);
    handleReset();
    acaoCancelar();
  };
  const handleReset = () => {
    const form = document.getElementById('formTelefone');
    const ddiInput = form.querySelector('#ddiMovel');
    const dddInput = form.querySelector('#dddMovel');
    const foneInput = form.querySelector('#foneMovel');
    if (ddiInput) {
      dddInput.value = dadosDependente?.ddiMovel || dados?.ddiMovel;
    }
    dddInput.value = dadosDependente?.dddMovel || dados?.dddMovel;
    foneInput.value = dadosDependente?.foneMovel || dados?.foneMovel;
  };
  return (
    <>
      {modalAbertoTelefone && (
        <form id="formTelefone" onSubmit={methods.handleSubmit(handleSubmit)}>
          <div className="dialog-main">
            <div className="container-telefone">
              {!brasileiro && (
                <div className="campo-txt campo-ddi">
                  <InputCadastroComIcone
                    type="text"
                    className="col-1"
                    campoClassName="campo-ddi"
                    iconName="ic-adicionar"
                    id="ddiMovel"
                    name="ddiMovel"
                    maxLength="2"
                    label={t('principal.forms.labels.ddi')}
                    defaultValue={dados?.ddiMovel}
                    {...formMethods}
                  />
                </div>
              )}
              <InputCadastro
                type="text"
                className="col-1"
                campoClassName="campo-ddd"
                id="dddMovel"
                name="dddMovel"
                maxLength="3"
                label={t('principal.forms.labels.ddd')}
                //defaultValue={dados?.dddMovel}
                {...formMethods}
              />
              {!brasileiro ? (
                <InputCelularEstrangeiro
                  type="text"
                  id="foneMovel"
                  name="foneMovel"
                  label={t('principal.forms.labels.phone')}
                  defaultValue={dados?.foneMovel}
                  {...formMethods}
                />
              ) : (
                <InputCelularAlteracao
                  type="text"
                  id="foneMovel"
                  name="foneMovel"
                  label={t('principal.forms.labels.phone')}
                  defaultValue={dados?.foneMovelFormatado}
                  {...formMethods}
                />
              )}
            </div>
          </div>

          <div className="dialog-footer">
            <button className="btn-txt btn-fecha-dialog" onClick={fechar}>
              {t('principal.forms.buttons.cancel')}
            </button>
            <button className="btn-pre" id="btn-telefone">
              {t('principal.forms.buttons.change')}
            </button>
          </div>
        </form>
      )}
      {modalAbertoToken && (
        <form>
          <div
            id="finaliza-cadastro"
            className="conteudo"
            style={{ padding: '0.5rem 0.25rem' }}
          >
            <div id="bem-vindo" className="card bg-superficie elev5">
              <img
                alt="Imagem de perfil da Carol"
                id="img-carol-boasvindas"
                src="/images/carol-perfil.png"
              />

              <h2>{t('principal.forms.titles.finalize_change')}</h2>

              <p className="txt-finalizacao">
                {t('principal.forms.messages.finalize_email_change', {
                  email: formatarEmailMascarado(dados?.email),
                })}
              </p>
              <div className="campo-txt">
                <InputToken />
              </div>
              <p
                className="txt-finalizacao"
                style={{ fontSize: '0.8rem', lineHeight: '1.3' }}
              >
                Caso tenha perdido acesso ao e-mail informado no cadastro, abra uma manifestação no&nbsp; 
                <a href="https://faleconosco.correios.com.br/faleconosco/app/cadastro/suporte/tecnologico-mc/index.php" target="_blank" rel="noopener noreferrer">
                  Fale Conosco.
                </a> 
                Solicite a atualização do e-mail no cadastro Meu Correios, 
                encaminhando e-mail atual, RG do representante legal, Ato da constituição da empresa e procuração legal, se houver.
              </p>
              <div className="btns-row" style={{ gap: '0.7rem', marginTop: '0.1rem' }}>
                <button
                  id="btn-reenviar"
                  type="button"
                  className="btn-cont"
                  onClick={reenviaToken}
                >
                  {t('principal.forms.buttons.resend_code')}
                </button>

                <button
                  id="btn-finalizar"
                  type="button"
                  className="btn-pre"
                  onClick={alterar}
                >
                  {t('principal.forms.buttons.finalize')}
                </button>
                <button
                  className="btn-txt btn-fecha-dialog"
                  onClick={fecharToken}
                >
                  {t('principal.forms.buttons.cancel')}
                </button>
              </div>
            </div>
          </div>
        </form>
      )}
    </>
  );
}
export default FormAlterarTelefone;
